import React, { useState } from "react";
import {
  Box,
  BoxProps,
  Img,
  usePrefersReducedMotion,
  useToken,
} from "@chakra-ui/react";
import { glare } from "./Lesson/CertificationStatus";

interface CertificationBadgeProps extends BoxProps {
  image: string | null;
  alt: string;
  delay?: string;
}

export function CertificationBadge({
  delay = "0",
  image,
  alt,
  ...props
}: CertificationBadgeProps) {
  const [imageLoaded, setImageLoaded] = useState(false); // want to wait for the certification image to load before firing the glare/shine animation
  const glareColor = useToken("colors", "whiteAlpha.700");
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <Box pos="relative" {...props}>
      <Img
        src={image ?? ""}
        alt={alt}
        mb="6"
        onLoad={() => setImageLoaded(true)}
      />
      {prefersReducedMotion && imageLoaded && image && (
        <Box
          boxSize="full"
          pos="absolute"
          top="0"
          left="0"
          bgSize="300%"
          backgroundImage={`linear-gradient(${[
            "90deg",
            "transparent",
            "transparent calc(100% / 3)",
            glareColor,
            "transparent calc(100% / 1.5)",
            "transparent",
          ]})`}
          css={{
            animationName: glare.toString(),
            animationDuration: "1000ms",
            animationDelay: delay,
            maskImage: `url(${image})`,
            maskSize: "100%",
          }}
        />
      )}
    </Box>
  );
}
